<div class="form-group">
  <label class="form-control-label break-word">{{model.value}}</label>
</div>
